
import React, { useState, useEffect } from "react";
import "./Client.css";
import axios from 'axios';
import { Search, X } from 'lucide-react';

const Client = () => {

  const API_BASE = "https://api.waraq.co/waraq/api/v1";

  const [data, setData] = useState([]);
  const [requeestID, setRequeestID] = useState(null)
  const [openRequests, setOpenRequests] = useState({});
  const [searchTerm, setSearchTerm] = useState('');


  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwtToken");
    return { Authorization: `${token}` };
  };

  const handleDownload = async (mediaId, name) => {
    try {

      let splitFileName = name?.split('.com/')[1];

      const url = `${API_BASE}/media/download/${mediaId}`;
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
        responseType: "blob",
      });
      const blob = response.data;
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      const contentDisposition = response.headers["content-disposition"];
      let fileName = splitFileName
      if (contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match?.[1]) {
          fileName = match[1].replace(/['"]/g, "");
        }
      }

      if (!fileName.includes(".")) {
        const contentType = response.headers["content-type"];
        const ext = contentType?.split("/")[1] || "bin";
        fileName = `${fileName}.${ext}`;
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };






  const getData = async () => {
    try {
      const res = await axios.get(
        "https://api.waraq.co/waraq/api/v1/client/translate/requests",
        { headers: getAuthHeaders() }
      );
      setData(res.data.data)
    } catch (err) {

      console.log('error when get the clients requerst ', err);
    }
  }

  const getDocByRequestID = async (id) => {
    setRequeestID(id)
    try {
      const res = await axios.get(
        `${API_BASE}/translate/docs?requestId=${id}`,
        { headers: getAuthHeaders() }
      );


      const mappedDocs = res.data.data.map((doc) => ({
        id: doc.id,
        document: doc.documentUrl,
        documentId: doc.documentId,
        finalTranslatedDocumentId: doc.finalTranslatedDocumentId,
        finalTranslatedDocumentUrl: doc.finalTranslatedDocumentUrl,
        templateUrl: doc.templateUrl,
        templateId: doc.templateId,
        translatedDocumentId: doc.translatedDocumentId,
        translatedDocumentUrl: doc.translatedDocumentUrl,
        creationDate: doc.creationDate,
      }));


      setOpenRequests((prev) => ({
        ...prev,
        [id]: prev[id] ? null : mappedDocs,
      }));


    } catch (err) {
      console.error("Error when get doc by request ID", err);
    }
  };

  // 

  const TASK_STATUS_STYLES = {
    UNASSIGNED: { backgroundColor: '#FF7777', color: '#000' },
    TRANSLATING: { backgroundColor: '#55D55B', color: '#000' },
    PROOFREADING: { backgroundColor: '#B991FF', color: '#000' },
    STAMPING: { backgroundColor: '#FFCD50', color: '#000' },
    COMPLETED: { backgroundColor: '#C7DDFF', color: '#000' },
  };

  const getStatusStyle = (status) => ({
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block',
    textAlign: 'center',
    ...(TASK_STATUS_STYLES[status] || { backgroundColor: '#dee2e6', color: '#333' }),
  });






  // 
  useEffect(() => {

    getData();
  }, [])

  const filteredData = data.filter((task) =>
    task.taskTitle?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (

    <>
      <div className='requests'>
        <h2 className="requests-title">My Requested</h2>
        <div className="input-wrapper">
          <div className="search-icon">
            <Search size={20} />
          </div>

          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search By Task title..."
            className="search-input"
          />

        </div>
        <div>
          {filteredData.length === 0 ? <>
            <div style={{
              textAlign: 'center',
              padding: '40px',
              margin: '40px 0',
              color: '#666',
              fontSize: '18px',
            }}>
              No requests found ...
            </div>
          </> : <>
            {filteredData.map((taskDetails, index) => (
              <div key={taskDetails.id || index}>

                <div
                  onClick={() => getDocByRequestID(taskDetails.id)}
                  className="task-row"
                  style={{
                    cursor: 'pointer',
                    margin: '30px 0px',
                    padding: '10px 30px',
                    borderRadius: '12px',
                    border: '1px solid #000',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px'
                  }}
                >
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Client</strong>
                    <br />
                    {taskDetails?.clientName ? taskDetails?.clientName : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Request Date</strong>
                    <br />
                    {taskDetails.requestDate ? taskDetails.requestDate.substring(0, 10) : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Task Title</strong>
                    <br />
                    {taskDetails.taskTitle ? taskDetails?.taskTitle : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Total Pages</strong>
                    <br />
                    {taskDetails.totalPages ? taskDetails.totalPages : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Translator</strong>
                    <br />
                    {taskDetails.translatorName ? taskDetails.translatorName : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Proofreader</strong>
                    <br />
                    {taskDetails.proofreaderName ? taskDetails.proofreaderName : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }} >Delivery Date</strong>
                    <br />
                    {taskDetails.deliveryDate ? taskDetails.deliveryDate.substring(0, 10) : 'N/A'}
                  </div>
                  <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                    <strong style={{ fontSize: '14px', fontWeight: '500' }}>Status</strong>
                    <br />
                    {/*                       <span style={getStatusStyle(task.status)}>{task.status}</span>
 */}
                    <span
                      style={getStatusStyle(taskDetails.status)}
                      // style={{ padding: '6px 16px', borderRadius: '20px', fontWeight: '500', fontSize: '14px' }}
                      className="status">
                      {taskDetails.status}
                    </span>
                  </div>

                </div>


                {openRequests[taskDetails.id] && (
                  <>
                    <table className="styled-table" style={{ marginTop: "10px", width: "100%" }}>
                      <thead className="styled-thead">
                        <tr>
                          <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Document (PDF)</th>
                          <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Template (Word)</th>
                          <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Translation (Word)</th>
                          <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Created At</th>
                        </tr>
                      </thead>
                      <tbody className="styled-tbody">
                        {openRequests[taskDetails.id].map((row, idx) => (
                          <tr className="styled-row" key={`${taskDetails.id}-${idx}`}>

                            <td className="styled-cell">
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                onClick={() => { handleDownload(row.documentId, row.document) }}
                              >
                                {row?.document.split('.com/')[1]?.length > 25
                                  ? row?.document.split('.com/')[1].slice(0, 25) + '...'
                                  : row?.document.split('.com/')[1]}
                              </a>
                            </td>

                            <td className="styled-cell">
                              {row.templateUrl ? (
                                <a
                                  onClick={() => { handleDownload(row.templateId, row.templateUrl) }}
                                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                >
                                  {row?.templateUrl.split('.com/')[1]?.length > 25
                                    ? row?.templateUrl.split('.com/')[1].slice(0, 25) + '...'
                                    : row?.templateUrl.split('.com/')[1]}

                                </a>
                              ) : (
                                "No file uploaded"
                              )}
                            </td>

                            <td className="styled-cell">
                              {row.translatedDocumentUrl ? (
                                <a
                                  onClick={() => { handleDownload(row.translatedDocumentId, row.translatedDocumentUrl) }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                >
                                  {row?.translatedDocumentUrl.split('.com/')[1]?.length > 25
                                    ? row?.translatedDocumentUrl.split('.com/')[1].slice(0, 25) + '...'
                                    : row?.translatedDocumentUrl.split('.com/')[1]}
                                </a>
                              ) : (
                                "No file uploaded"
                              )}
                            </td>

                            <td className="styled-cell">
                              {row?.creationDate?.substring(0, 10) || "—"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                  </>
                )}



              </div>
            ))}
          </>}


        </div>
      </div>
    </>
  );
};

export default Client;

